/**
 * @generated SignedSource<<0d0099b45c6854e0f3cf7a40446e0ec3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type CMSPageStatus = "ended" | "live" | "scheduled" | "variant" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type NftExhibitionLayout_viewer$data = {
  readonly cmsNftExhibitionPage?: {
    readonly heroBanner: ReadonlyArray<{
      readonly bannerConfig: {
        readonly eyeBrow?: string | null;
      } | null;
    } | null> | null;
    readonly status: CMSPageStatus | null;
    readonly " $fragmentSpreads": FragmentRefs<"HeroBannerCarousel_cmsNftExhibitionPage" | "NftExhibitionTileGrid_cmsNftExhibitionPage">;
  } | null;
  readonly cmsNftFeaturedPages?: ReadonlyArray<{
    readonly heroBanner: ReadonlyArray<{
      readonly bannerConfig: {
        readonly eyeBrow?: string | null;
      } | null;
    } | null> | null;
    readonly status: CMSPageStatus | null;
    readonly " $fragmentSpreads": FragmentRefs<"HeroBannerCarousel_cmsNftExhibitionPage" | "NftExhibitionTileGrid_cmsNftExhibitionPage">;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"NftExhibitionTileGrid_viewer">;
  readonly " $fragmentType": "NftExhibitionLayout_viewer";
};
export type NftExhibitionLayout_viewer$key = {
  readonly " $data"?: NftExhibitionLayout_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftExhibitionLayout_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "NftCmsExhibitionHeroBannerType",
    "kind": "LinkedField",
    "name": "heroBanner",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "bannerConfig",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "eyeBrow",
                "storageKey": null
              }
            ],
            "type": "NftCmsExhibitionHtmlBannerType",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "HeroBannerCarousel_cmsNftExhibitionPage"
  },
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "NftExhibitionTileGrid_cmsNftExhibitionPage"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    },
    {
      "kind": "RootArgument",
      "name": "first"
    },
    {
      "kind": "RootArgument",
      "name": "isFeatured"
    },
    {
      "kind": "RootArgument",
      "name": "pageId"
    },
    {
      "kind": "RootArgument",
      "name": "urlLabel"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": require('./NftExhibitionLayoutRefetchQuery.graphql')
    }
  },
  "name": "NftExhibitionLayout_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftExhibitionTileGrid_viewer"
    },
    {
      "condition": "isFeatured",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "rootId",
              "variableName": "pageId"
            },
            {
              "kind": "Variable",
              "name": "urlLabel",
              "variableName": "urlLabel"
            }
          ],
          "concreteType": "NftCmsExhibitionPage",
          "kind": "LinkedField",
          "name": "cmsNftExhibitionPage",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ]
    },
    {
      "condition": "isFeatured",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "NftCmsExhibitionPage",
          "kind": "LinkedField",
          "name": "cmsNftFeaturedPages",
          "plural": true,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "b2164b696419fb65606b7f5622ae345a";

export default node;
